import React from 'react';

const Tooltip = ({ children, content }) => {
  return (
    <div title={content} style={{ display: 'inline-block', cursor: 'help' }}>
      {children}
    </div>
  );
};

export default Tooltip;